import { Fragment, useMemo } from "react";

import { Observation } from "@medplum/fhirtypes";

import { Group, List, Table } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { getCumulativeBloodLossRowValues } from "@/encounters/components/EncounterLabor/utils/labor";

import LastUpdated from "../../../EncounterLaborTable/LaborRow/Common/LastUpdated";
import TimeCell, { TimeCellVariants } from "../../../EncounterLaborTable/LaborRow/Common/TimeCell";

interface ClientCumulativeBloodLossRowProps {
  time: string;
  observation: Observation | undefined;
  showNumbersOnly?: boolean;
  showPreviousVersions?: boolean;
  onRefresh?: () => Promise<void>;
  isViewOnly: boolean;
}

export default function ClientCumulativeBloodLossRow({
  time,
  observation,
  showNumbersOnly,
  showPreviousVersions = true,
  onRefresh,
  isViewOnly,
}: ClientCumulativeBloodLossRowProps) {
  const { cumulative, hasAnswers } = useMemo(
    () => getCumulativeBloodLossRowValues(observation),
    [observation],
  );

  if (!observation) return null;

  if (!hasAnswers) return null;

  return (
    <Fragment>
      {!showNumbersOnly && (
        <Table.Tr bg="white">
          <TimeCell time={time} rowSpan={1} isViewOnly={true} variant={TimeCellVariants.Gray} />
          <Table.Td p="md" colSpan={10}>
            <TextWrapper size="sm">Cumulative Blood Loss:</TextWrapper>
            <List fz="sm" withPadding spacing="xs">
              <List.Item>
                <Group gap="xs">
                  <TextWrapper size="sm" variant="bold">
                    Amount:
                  </TextWrapper>
                  <TextWrapper size="sm">{cumulative} cc</TextWrapper>
                </Group>
              </List.Item>
            </List>
            <LastUpdated observation={observation} showPreviousVersions={false} />
          </Table.Td>
        </Table.Tr>
      )}
    </Fragment>
  );
}
